import { Link, router } from "@inertiajs/react"
import { BackofficeLayout } from "@/components/layout/BackofficeLayout"
import { SearchInput } from "@/components/shared/SearchInput"
import { Pagination, PaginationMeta } from "@/components/shared/Pagination"
import { Badge } from "@/components/ui/badge"
import { StageBadge } from '@/components/shared/StageBadge'
import type { BackofficeNomineeDirector } from "@/types"

type Props = {
  nominee_directors: BackofficeNomineeDirector[]
  search: string
  pagination: PaginationMeta
}

export default function BackofficeNomineeDirectorsIndex({ nominee_directors, search, pagination }: Props) {
  return (
    <BackofficeLayout title="Nominee Director Services" breadcrumbs={[{ label: "Backoffice", href: "/backoffice/dashboard" }, { label: "Nominee Directors" }]}>
      <div className="mb-8">
        <h1 className="text-xl font-semibold tracking-tight">Nominee Director Services</h1>
        <p className="text-sm text-muted-foreground">{pagination.total} {pagination.total === 1 ? "service" : "services"}</p>
      </div>

      <SearchInput value={search} placeholder="Search services..." />

      <div className="mt-4">
        {nominee_directors.length === 0 ? (
          <div className="border rounded-lg py-16 text-center">
            <h3 className="text-sm font-medium text-foreground mb-1">No services yet</h3>
          </div>
        ) : (
          <div className="border rounded-lg">
            {nominee_directors.map((nd, i) => (
              <div
                key={nd.id}
                className={`px-4 py-3 cursor-pointer hover:bg-muted/50 transition-colors ${i > 0 ? "border-t" : ""}`}
                onClick={() => router.visit(`/backoffice/nominee_directors/${nd.id}`)}
              >
                <div className="flex items-center justify-between">
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <Link href={`/backoffice/nominee_directors/${nd.id}`} className="text-sm font-medium hover:underline">{nd.business_name}</Link>
                      <span className="text-[12px] text-muted-foreground">{nd.type_name}</span>
                    </div>
                    <div className="text-xs text-muted-foreground mt-0.5">
                      {nd.account_name} · {nd.jurisdiction_label || "—"} · {nd.duration_months} months
                    </div>
                  </div>
                  <div className="ml-4">
                    <StageBadge stage={nd.stage} variant="service" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-4">
        <Pagination pagination={pagination} />
      </div>
    </BackofficeLayout>
  )
}
